import {
  ConnectionsAction,
  SET_ACCOUNTING_CONNECTION,
  SET_AMAZON_BUSINESS_CONNECTION,
  SET_EMBURSE_CARDS_CONNECTIONS,
  SET_LOADING_EMBURSE_CARDS_CONNECTIONS,
  SET_SALESFORCE_CONNECTION,
  SET_SLACK_CONNECTION
} from '@Actions/connectionsActions';

import { IAmazonBusinessConnection } from '@Shared/api_responses/amazonBusinessConnection';
import { IAccountingConnectionModel, ISalesforceConnectionModel, ISlackConnectionModel } from '@Shared/models';

interface IConnectionsState {
  accountingConnection: IAccountingConnectionModel;
  salesforceConnection: ISalesforceConnectionModel;
  slackConnection: ISlackConnectionModel;
  amazonBusinessConnection: IAmazonBusinessConnection;
  emburseCardsConnections: any[];
  emburseCardsConnectionsIsLoading: boolean;
}

export const defaultState: IConnectionsState = {
  accountingConnection: null,
  salesforceConnection: null,
  slackConnection: null,
  amazonBusinessConnection: null,
  emburseCardsConnections: null,
  emburseCardsConnectionsIsLoading: false
};

export function connectionsReducer(state = defaultState, action: ConnectionsAction) {
  switch (action.type) {
    case SET_ACCOUNTING_CONNECTION:
      return {
        ...state,
        accountingConnection: action.payload
      };
    case SET_SALESFORCE_CONNECTION:
      return {
        ...state,
        salesforceConnection: action.payload
      };
    case SET_SLACK_CONNECTION:
      return {
        ...state,
        slackConnection: action.payload
      };
    case SET_AMAZON_BUSINESS_CONNECTION:
      return {
        ...state,
        amazonBusinessConnection: action.payload
      };
    case SET_EMBURSE_CARDS_CONNECTIONS:
      return {
        ...state,
        emburseCardsConnections: action.payload
      };
    case SET_LOADING_EMBURSE_CARDS_CONNECTIONS:
      return {
        ...state,
        emburseCardsConnectionsIsLoading: action.payload
      };
    default:
      return state;
  }
}
